import { validationMessage } from 'vuelidate-messages'
import { messages, validationPass, isDateValid, isDateBeforeMaxDate } from '@/lib/validation-helpers'
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'

export const validations = {
  validations: {
    formData: {
      product_id: {
        required
      },
      start_date: {
        required,
        isDateValid(val, data) {
          if (data.one_time_purchase) return true
          if (!data.end_date || !isDateValid.call(this, data.end_date)) return true
          return isDateValid.call(this, val)
        }
      },
      end_date: {
        required: requiredIf(formData => !formData.one_time_purchase),
        isDateValid(val, data) {
          if (data.one_time_purchase) return true
          if (!data.start_date || !isDateValid.call(this, data.start_date)) return true
          return isDateValid.call(this, val)
        },
        isDateBeforeMaxDate(val, data) {
          if (data.one_time_purchase) return true
          return isDateBeforeMaxDate.call(this, data.start_date, val, `Must be after (${data.start_date})`)
        }
      },
      name_reference: {
        maxLength: maxLength(64)
      },
      owner_id: {
        required
      },
      cancellation_deadline: {
        isDateValid(val) {
          return isDateValid.call(this, val)
        },
        isDateBeforeMaxDate(val, formData) {
          return isDateBeforeMaxDate.call(this, val, formData.start_date)
        }
      },
      currency: {
        required,
        maxLength: maxLength(3)
      },
      financial_period_id: {
        required
      }
    }
  },

  methods: {
    $v_displayMessage: validationMessage(messages),
    $v_validationPass: validationPass
  }
}
